export default "__VITE_ASSET__BCQXiYvh__"